import { Config as C } from 'ets-fe-ng-sdk';

export class Config extends C {
  static appName = `Insurance Regulatory Platform`;
}
